import store from './store';

export default store;



// WEBPACK FOOTER //
// ./src/app/browse-filters/index.js